/* OVERAALL — single per-order packaging upgrade (Shopify Ajax Cart API). */
(()=>{'use strict';
 const ADDON=52981678407911;
 const roots=[...document.querySelectorAll('[data-ov-packaging]')];
 if(!roots.length)return;
 const prefix=(window.Shopify?.routes?.root||'/').replace(/\/?$/,'/');
 const isFullCart=!!document.querySelector('[data-ov-packaging="full-cart"]');
 let busy=false,lastCart=null;
 const feeLines=cart=>(cart?.items||[]).filter(i=>Number(i.variant_id)===ADDON);
 const clothingLines=cart=>(cart?.items||[]).filter(i=>Number(i.variant_id)!==ADDON);
 async function request(path,payload){
   const resp=await fetch(prefix+path,{method:payload?'POST':'GET',credentials:'same-origin',headers:{Accept:'application/json',...(payload?{'Content-Type':'application/json'}:{})},...(payload?{body:JSON.stringify(payload)}:{})});
   const data=await resp.json().catch(()=>({}));
   if(!resp.ok)throw new Error(data.description||data.message||'Could not update packaging.');
   return data;
 }
 const read=()=>request('cart.js');
 function notice(message){for(const root of roots){const target=root.querySelector('[data-ov-packaging-status]');if(target)target.textContent=message||'';}}
 function lock(value){
   busy=value;
   for(const root of roots){root.dataset.busy=String(value);root.querySelectorAll('input[type="radio"]').forEach(input=>input.disabled=value);}
   document.querySelectorAll('.ov62-cart-summary button[name="checkout"],.ov2-cart-actions button[name="checkout"]').forEach(btn=>btn.disabled=value);
 }
 function paint(cart){
   if(!cart)return;
   lastCart=cart;
   const hasProducts=clothingLines(cart).length>0;
   const custom=feeLines(cart).length>0;
   for(const root of roots){
     root.hidden=!hasProducts;
     const selected=root.querySelector('input[value="'+(custom?'custom':'standard')+'"]');
     if(selected)selected.checked=true;
   }
   // An add-on alone should never remain as a purchasable order.
   if(!hasProducts&&custom&&!busy)void selectPackaging('standard',true);
 }
 async function changeLine(key,qty){return request('cart/change.js',{id:key,quantity:qty});}
 async function selectPackaging(desired,automatic=false){
   if(busy)return;
   lock(true);notice(automatic?'':'UPDATING YOUR PACKAGING…');
   try{
     let cart=await read();
     const lines=feeLines(cart);
     if(desired==='custom'){
       if(!clothingLines(cart).length)throw new Error('Add a piece to your bag first.');
       if(!lines.length){await request('cart/add.js',{items:[{id:ADDON,quantity:1}]});}
       else{
         for(let idx=0;idx<lines.length;idx++){
           if(idx>0||lines[idx].quantity!==1)await changeLine(lines[idx].key,idx===0?1:0);
         }
       }
     }else{
       for(const line of lines)await changeLine(line.key,0);
     }
     await request('cart/update.js',{attributes:{Packaging:desired==='custom'?'Custom Packaging':'Standard Packaging'}});
     cart=await read();
     paint(cart);
     if(window.OVERAALLCart?.refresh)await window.OVERAALLCart.refresh();
     notice(automatic?'':desired==='custom'?'CUSTOM PACKAGING ADDED — $5.00':'STANDARD PACKAGING SELECTED');
     if(isFullCart&&!automatic){window.location.reload();return;}
   }catch(err){
     notice(err.message||'Unable to save packaging. Please try again.');
     try{paint(await read());}catch(_){}
   }finally{lock(false);}
 }
 for(const root of roots)root.addEventListener('change',e=>{
   if(e.target.matches('input[type="radio"]'))void selectPackaging(e.target.value);
 });
 document.addEventListener('overaall:cart-render',e=>paint(e.detail?.cart));
 if(isFullCart)void read().then(paint).catch(()=>notice('Unable to load packaging choices.'));
})();
